// Export the Component Definition for use in Contentful Studio
export {IconHighlightContentfulComponentDefinition} from './IconHighlightContentfulDefinition';
export {default} from './IconHighlight';
